import MyFlow from "flow/MyFlow";

export default class DefaultViewModel {
    constructor(private readonly myFlow: MyFlow) {}

    activate() {
        return this.myFlow.deferred().resolve().promise();
    }
}
